import React from 'react';
import clsx from 'clsx';
import styles from './RadiosWrap.module.scss';

type Props = {
  direction: 'row' | 'column';
  className?: string;
  children: React.ReactNode;
};

const RadiosWrap = React.forwardRef<HTMLDivElement, Props>((props, ref): JSX.Element => {
  const {
    direction,
    className,
    children,
    ...other
  } = props;

  return (
    <div
      ref={ref}
      className={clsx(styles.root, styles[direction], className)}
      {...other}
    >
      {children}
    </div>
  );
});

export default React.memo(RadiosWrap);
